// src/hooks/usePreferencesModal.ts
import useUiStore from "../store/useUiStore.ts";
import CreateNewProjectModal from "../components/CreateProjectModal/CreateNewProjectModal.tsx";
import {ICreateNewProjectState} from "../reducers/createNewProjectReducer.ts";

export const useCreateNewProjectModal = () => {
  const {openModal} = useUiStore();

  return (remainingMinutes: number, handleCreateProject: (state: ICreateNewProjectState) => Promise<void>) => {
    openModal(
      <CreateNewProjectModal remainingMinutes={remainingMinutes} createNewProject={handleCreateProject}/>,
      {
        className: "md:!p-0 overflow-hidden",
        classWrap: "max-w-[48rem] md:min-h-screen-ios md:rounded-none",
        classButtonClose: "hidden md:block md:absolute md:top-5 md:right-5 dark:fill-n-400",
        classOverlay: "md:bg-n-100",
      }
    );
  };
};